/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import CustomLink from 'components/shared/CustomLink'

const ButtonShell = ({ isAnchor, to, children, className, target }) => (
  !isAnchor ? (
    <CustomLink to={to} className={className}>{children}</CustomLink>
  ) : (
    <a href={to} className={className} target={target}>{children}</a>
  )
)

export default ButtonShell